<script setup lang="ts">
import { computed } from 'vue'

import { HeadingType } from '@xcel-next/core/enums'

import Icon from '../shared/Icon.vue'

import type { HorizontalLineParagraph } from '../../utils/paragraph-schema/paragraphs'

const props = defineProps<{
  horizontalLine: HorizontalLineParagraph['horizontalLine']
}>()

const headingTag = computed(() => {
  return props.horizontalLine?.heading && props.horizontalLine.heading !== HeadingType.none ? props.horizontalLine.heading : 'div'
})
</script>

<template>
  <div class="bx-content">
    <div class="bx-teaser-dividing-line bx-typo--dividing-line">
      <Icon v-if="horizontalLine?.iconName"
            :name="horizontalLine?.iconName" />
      <component :is="headingTag">
        <span v-if="horizontalLine?.lineTitle"
              class="bx-teaser-dividing-line__text">
          {{ horizontalLine?.lineTitle }}
        </span>
      </component>
    </div>
  </div>
</template>
